import { Pipe, PipeTransform, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { WarehouseReleaseStatusProviderService } from '../providers/warehouse-release-status-provider.service';
import { WarehouseReleaseStatus } from '../enums/warehouse-release-status';

@Pipe({
  name: 'warehouseReleaseStatus',
  standalone: true,
})
export class WarehouseReleaseStatusPipe implements PipeTransform {
  private readonly provider = inject(WarehouseReleaseStatusProviderService);

  public transform(status: WarehouseReleaseStatus): Observable<string> {
    return this.provider.label(status);
  }
}
